import {createContext, useContext, useState} from "react";

import {AppTheme, basicTheme} from "../model/Constants";
import {getTheme} from "../Utils";

export type ThemeProps = {
  theme: AppTheme;
  refreshTheme: () => void;
};

const baseF = ()=> {  };
const themeContext = createContext<ThemeProps>({theme: basicTheme, refreshTheme: baseF});

export function useTheme() {
  return useContext(themeContext);
}

export function ThemeProvider({ children }: any) {
    const [theme, setTheme] = useState<AppTheme>(getTheme());

    const refreshTheme = ()=> {
        setTheme(getTheme());
        };

  return (
    <themeContext.Provider
      value={{theme, refreshTheme}}
    >
      {children}
    </themeContext.Provider>
  );
}
